import Modal, { ModalBody } from 'components/common/modal';

import Container from 'components/common/container';
import React from 'react';
import { Translate } from '~/i18n';

type CookieModalProps = {
   open: any;
};

const CookieModal = ({ open }: CookieModalProps) => {
   return (
      <Modal open={open} size="sm">
         <ModalBody className="transition-all duration-150 ease-in-out ">
            <div className="py-4 px-4">
               <div className="text-xl text-center font-bold bg-white py-4">
                  <span>
                     <Translate id="common:cookies are disabled" />
                  </span>
               </div>
               <Container>
                  <div className="pb-4 text-center text-sm rtl:text-base">
                     <span>
                        <Translate id="common:cookies disabled message" parseHTML />
                     </span>
                  </div>
               </Container>
            </div>
         </ModalBody>
      </Modal>
   );
};

export default CookieModal;
